import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { ApiService } from './base/services/data/api.service';
import { AppBaseSharedModule } from './base/app-base-shared.module';
import { AccessDeniedModule } from './base/modules/access-denied/access-denied.module';

import { StartComponent } from './components/start/start.component';
import { CounterComponent } from './components/counter/counter.component';

import { AppRoutingModule } from './app-routing.module';

import { DriversLookupService } from './services/lookup-tables/resources/drivers-lookup.service';
import { SuburbsService } from './services/lookup-tables/suburbs/suburbs.service';
import { TrucksLookupService } from './services/lookup-tables/resources/trucks-lookup.service';
import { TrailersLookupService } from './services/lookup-tables/resources/trailers-lookup.service';
import { VehiclesLookupService } from './services/lookup-tables/resources/vehicles-lookup.service';

@NgModule({
    declarations: [
        CounterComponent,
        StartComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        AppBaseSharedModule,
        AppRoutingModule,
        AccessDeniedModule
    ],
    providers: [ApiService, DriversLookupService,
        SuburbsService,
        TrailersLookupService, TrucksLookupService, VehiclesLookupService]
})

export class AppModuleShared {
}